import script from "./SelectNews.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectNews.vue?vue&type=script&setup=true&lang=js"

import "./SelectNews.vue?vue&type=style&index=0&id=d84337d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d84337d2"]])

export default __exports__